/* eslint-disable */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import MisconceptionCards from '../../components/MisconceptionCards';
import { PSA_CARD_ICONS } from './iconMap';
import WhyStudentTargetReasons from '../../components/WhyStudentTargetReasons';
import IconCardCarousel from '../../components/IconCardCarousel';
import PersonalDataIllustration from '../../../../../../assets/student-training/pypi/section1-img1.png';
interface ISection1Props {
  settings: any;
}

const renderNumberIcon = (num: number) => (
  <div className="icc-card-number-icon">{String(num).padStart(2, '0')}</div>
);

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const handleMisconceptionCardsComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-pypi-section1-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  const personalDataItems = (paragraphsSettings?.section1Items ?? []).map(
    (content: string, index: number) => ({
      icon: renderNumberIcon(index + 1),
      title: '',
      content,
    })
  );

  return (
    <div className="topic-section-1">
      <IconCardCarousel
        mainTitle={paragraphsSettings.section1Title}
        description={paragraphsSettings.section1Desc}
        illustration={<img src={PersonalDataIllustration} alt="" />}
        items={personalDataItems}
        defaultActive={0}
      />
      <MisconceptionCards
        subTitle={paragraphsSettings?.risksTitle}
        items={paragraphsSettings?.risks}
        tips={paragraphsSettings?.risksTips}
        icons={PSA_CARD_ICONS}
        id="student-training-pypi-section1-1"
        onComplete={handleMisconceptionCardsComplete}
      />
    </div>
  );
};

export default Section1;
